import Keycloak from "keycloak-js";
const keycloak = new Keycloak({
 url: "https://auth.interlogica.it/auth",
 realm: "interlogica",
 clientId: "buddy",
});

export default keycloak;